import React, {Component} from 'react';
import styled from 'styled-components';
import media from '../MediaQueries.js';
import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem,
        NavLink, Container, Row, Col, Jumbotron, Button } from 'reactstrap';

const CandleInfo = (props) => ( 
	<Container_s id="AboutOurCandlesSectionID">
		<h3>About Our Candles</h3>
		<Row>
			<Col xs="12" >
				<img src={require("../media/CandlePics/palmwaxcottonwickimage.jpg")}></img>

				{/*<Button size="md">Learn more</Button>*/}
			</Col>
			<Col xs="12" md="8">
				<p>We use cotton wicks that are lead free. Rest assured that your pets and kids are safe around them.
				   Also, our candles are sourced from sustainably sourced palm wax. Choosing Primitive's candles helps preserve our rainforests
				   & keep us <span>environmentally friendly!</span>
				</p>
			</Col>
			<Col xs="12" md="4">
				<OuthouseContainer>
					<Outhouse src={require("../media/outhousedark.jpg")}></Outhouse>
				</OuthouseContainer>
			</Col>
		</Row>
	</Container_s>
);

export default CandleInfo;

const Container_s = styled(Container)`
	padding: 20px 15px 5px 15px!important;
	margin: 0 auto!important;

	h3 {
		margin-bottom: 15px;
		font-weight: bold;
		font-size: 36px;
		text-align: center;
		${media.md` font-size: 38px; `}
		${media.lg` font-size: 40px; `}
		${media.xl` font-size: 42px; `}
		${media.xxl` font-size: 44px; `}
	}
	img {
		width: 100%;
		height: auto;
		display: block;
		margin: 0 auto;
		margin-bottom: 15px;
	}
	p {
		font-family: 'Raleway';
		font-size: 16px;
		margin: 0 auto;
		margin-bottom: 15px;
		text-align: left;

		span {
			color: rgb(118, 69, 31);
			font-weight: bold;
		}

		${media.md` font-size: 17px; `}
		${media.lg` font-size: 18px; `}
		${media.xl` font-size: 19px; `}
	}
	${media.md`
		text-align: left;
	`}
	Button {
		margin-bottom: 30px;
		display: block!important;
		margin: 0 auto;
		margin-bottom: 30px;
		color: white!important;
		border: 0px!important;
		background-color: #8B572A!important;
		font-family: 'Raleway';
		font-size: 16px;
		cursor: pointer;
		${media.lg`
			font-size: 18px;
		`}
	}

`;

const OuthouseContainer = styled.div`
	text-align: right;
	margin: 0 30px 0 30px;
`;

const Outhouse = styled.img`
	width: 150px!important;
	height: 100px!important;
	display: inline-block!important;
	text-align: left;
`;


// WEBPACK FOOTER //
// ./src/components/CandleInfo.js